<template>
  <div class="card">
    <h5 class="card-header text-truncate w-100">
      <span class="badge bg-primary rounded-pill bx-pull-right font-size-12">
        Total
      </span>
      Clientes
    </h5>
    <div class="card-body">
      <div class="row">
        <div class="col-4 text-center">
          <router-link :to="{ name: 'listadoClientes' }" title="Activos">
            <div class="avatar mx-auto">
              <div 
                class="avatar-title rounded-circle bg-info bg-gradient" 
                :class="activos <= 999 ? 'font-size-20' : 'font-size-16'"  
                :title="activos"
              >
                {{ activosFormato }}
              </div>
            </div>
            <div class="text-info text-truncate w-100">
              Activos
            </div>
          </router-link>
        </div>
        <div class="col-4 text-center">
          <a :href="clientesSuspendidos()" title="Suspendidos">
            <div class="avatar mx-auto">
              <div 
                class="avatar-title rounded-circle bg-warning bg-gradient" 
                :class="suspendidos <= 999 ? 'font-size-20' : 'font-size-16'" 
                :title="suspendidos"
              >
                {{ suspendidosFormato }}
              </div>
            </div>
            <div class="text-warning text-truncate w-100">
              Suspendidos
            </div>
          </a>
        </div>
        <div class="col-4 text-center">
          <router-link :to="{ name: 'listadoClientes' }" title="Clientes">
            <div class="avatar mx-auto">
              <div class="avatar-title rounded-circle bg-primary bg-gradient font-size-20">
                <i class="mdi mdi-account-group"></i>
              </div>
            </div>
            <div class="text-truncate w-100">
              Clientes
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClienteSrv from '@/services/ClienteSrv.js'
export default {
  name: 'WClientes',
  data() {
    return {
      activos: sessionStorage.getItem('argusblack.wclientes.activos') || 0,
      suspendidos: sessionStorage.getItem('argusblack.wclientes.suspendidos') || 0,
      intervals: {
        actualizacion: null
      },
      baseUrl: window.location.origin,
    }
  },
  created() {
    var self = this

    this.actualizar()
    this.intervals.actualizacion = setInterval(function() {
      self.actualizar()
    }, 60000)
  },
  computed:  {
    activosFormato: function() {
      return this.activos <= 9999 ? this.activos : '999+'
    },
    suspendidosFormato: function() {
      return this.suspendidos <= 9999 ? this.suspendidos : '999+'
    }
  },
  beforeUnmount() {
    clearInterval(this.intervals.actualizacion)
  },
  methods: {
    actualizar() {
      var self = this

      // Clientes activos
      ClienteSrv.cantidad({activos: true}).then(response => {
        self.activos = response.data
        sessionStorage.setItem('argusblack.wclientes.activos', self.activos)
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje):null
        console.log(error)
      })

      // Clientes suspendidos
      ClienteSrv.nSuspendidos().then(response => {
        self.suspendidos = response.data
        sessionStorage.setItem(
          'argusblack.wclientes.suspendidos',
          self.suspendidos
        )
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje):null
        console.log(error)
      })
    },
    clientesSuspendidos() {
      var self = this
      let url = self.baseUrl+'/clientes?dato=&n_pag=1&n_cln_pag=10&filtros=%7B"activos"%3Atrue,"suspendidos"%3Atrue,"atrasados"%3Afalse,"retirados"%3Afalse%7D'
      return url
    }
  }
}
</script>